import BuildChangeAlert from '../../components/BuildChangeAlert';
import BuildDetails from '../../components/BuildDetails';

export const Footer = () => {
  return (
    <>
      <footer
        className="text-muted-foreground fixed right-0 bottom-0 flex min-h-4 w-full items-center justify-center gap-2
          bg-transparent p-1 text-[12px]"
      />

      <BuildDetails />
      <BuildChangeAlert />
    </>
  );
};
